import React from 'react';
import { connect } from 'react-redux';
import { withRouter as _withRouter } from 'react-router-dom';
import { withI18n } from '@lingui/react';

const translate = (i18n) =>
    i18n && i18n._
        ? i18n._.bind(i18n)
        : () => {
              throw Error('@clearscore/redux.connect: Text can not be translated as no catalogue has been provided');
          };

const withLingui = (lingui, getI18n) => (Component) =>
    getI18n
        ? withI18n(lingui)(({ i18n, i18nHash, ...props }) => (
              <Component i18n={getI18n({ translate: translate(i18nHash || i18n) })} {...props} />
          ))
        : Component;

const withRouter = (useRouter) => (Component) => (useRouter ? _withRouter(Component) : Component);

export default (mapState, mapDispatch, { mergeProps, lingui, getI18n, useRouter, options } = {}) => (Component) =>
    withRouter(useRouter)(withLingui(lingui, getI18n)(connect(mapState, mapDispatch, mergeProps, options)(Component)));
